import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from 'helpers/api'
import { toast } from "react-toastify";
import { t } from 'i18next';

export const getAssets = createAsyncThunk('asset/list', async (_, { dispatch }) => {
  try {
    const response = await api.get("mobile/asset/list");
    if (!response.data.Result) {
      toast.error(t(`api.errors.${response?.data?.Code}`));
    }
    return response?.data;
  } catch (error) {
    toast.error(t('api.errors.error'));
    throw error;
  }
})

export const assetReviews = createAsyncThunk('asset/reviews', async (params, { dispatch }) => {
  try {
    const response = await api.get("mobile/asset/reviews/" + params);
    if (!response.data.Result) {
      toast.error(t(`api.errors.${response?.data?.Code}`));
    }
    return response?.data;
  } catch (error) {
    toast.error(t('api.errors.error'));
    throw error;
  }
})

export const userAssets = createAsyncThunk('asset/user', async (_, { dispatch }) => {
  try {
    const response = await api.get("mobile/asset/user");
    if (!response.data.Result) {
      toast.error(t(`api.errors.${response?.data?.Code}`));
    }
    return response?.data;
  } catch (error) {
    toast.error(t('api.errors.error'));
    throw error;
  }
})

export const assetDetails = createAsyncThunk('asset/details', async (params, { dispatch }) => {
  try {
    const response = await api.get("mobile/asset/details/" + params);
    if (!response.data.Result) {
      toast.error(t(`api.errors.${response?.data?.Code}`));
    }
    return response?.data;
  } catch (error) {
    toast.error(t('api.errors.error'));
    throw error;
  }
})

export const retrieveAsset = createAsyncThunk('asset/retrieve', async (params, { dispatch }) => {
  try {
    const response = await api.post("mobile/asset/retrieve/" + params);
    if (!response.data.Result) {
      toast.error(t(`api.errors.${response?.data?.Code}`));
    }
    return response?.data;
  } catch (error) {
    toast.error(t('api.errors.error'));
    throw error;
  }
})

export const returnAsset = createAsyncThunk('asset/return', async (params, { dispatch }) => {
  try {
    const response = await api.post("mobile/asset/return/" + params);
    if (!response.data.Result) {
      toast.error(t(`api.errors.${response?.data?.Code}`));
    }
    return response?.data;
  } catch (error) {
    toast.error(t('api.errors.error'));
    throw error;
  }
})

const initialState = {
  list: false,
  user: false,
  selected: false,
  reviews: false
};

export const assetSlice = createSlice({
  name: "asset",
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(getAssets.fulfilled, (state, action) => {
      state.list = action.payload.Data
    })
    builder.addCase(userAssets.fulfilled, (state, action) => {
      state.user = action.payload.Data
    })
    builder.addCase(assetDetails.fulfilled, (state, action) => {
      state.selected = action.payload.Data
    })
    builder.addCase(assetReviews.fulfilled, (state, action) => {
      state.reviews = action.payload.Data
    })
  }
});

export default assetSlice.reducer;
